import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BaseUtilities } from '@shared/library/configs/helpers/base-utilities';
import { TypeRouteEnum } from '@core/interfaces/route-type';
import { CookieService } from 'ngx-cookie-service';

export const userIsLoggedInGuard: CanActivateFn = (route) => {
  const _router: Router = inject(Router);
  const cookieSvc: CookieService = inject(CookieService);

  const { data } = route as any as { data: { type: TypeRouteEnum } };
  const { type } = data;

  let isAccessValidation: boolean = false;
  let urlTree: string = '';

  const sesionStorageUserItem = cookieSvc.get('user');
  const isSesionUser = BaseUtilities.getValidObj(sesionStorageUserItem);

  switch (type) {
    case TypeRouteEnum.PRIVATE:
      isAccessValidation = !!isSesionUser;
      urlTree = '/login';
      break;

    case TypeRouteEnum.PUBLIC:
      if (route.queryParamMap.has('mcp_oauth')) return true;
      isAccessValidation = !isSesionUser;
      urlTree = '/home';
      break;

    default:
      break;
  }

  return isAccessValidation || _router.createUrlTree([urlTree]);
};
